import { Menu, MenuItem } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../reduxService/hooks';
import { changeLanguage, loadLanguages } from '../../../../localization';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { ILanguageButtonProps } from './ILanguageButton';
import { ILanguage } from '../../../../api/IApiResponse';

const LanguageButton = (props: ILanguageButtonProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [languages, setLanguages] = React.useState<ILanguage[]>([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const projectInfo = useAppSelector(selectProjectInfo);

    const { t } = useTranslation();
    const open = Boolean(anchorEl);
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = (language: string) => {
        changeLanguage(language);
        setAnchorEl(null);
    };

    React.useEffect(() => {
        const hardcodedLanguages: ILanguage[] = [
            { languageCode: 'en-US', languageFileName: 'MACREAD_en.json', description: 'English' },
            // { languageCode: 'it-IT', languageFileName: 'MACRO_it.json', description: 'Italiano' },
            // { languageCode: 'es-ES', languageFileName: 'MACRO_es.json', description: 'Spanish' },
            // { languageCode: 'fr-FR', languageFileName: 'MACRO_fr.json', description: 'French' },
            { languageCode: 'pt-PT', languageFileName: 'MACREAD_pt.json', description: 'Português' },
            // { languageCode: 'zh-CN', languageFileName: 'MACRO_zh.json', description: 'Chinese' },
        ];
        setLanguages(hardcodedLanguages);
        loadLanguages(hardcodedLanguages);
    }, []);

    return (
        <>
            <button type="button" className={props.className} onClick={handleClick}>
                <i className="fa-solid fa-globe" />
                {t('header_language_button')}
                <i className="fa-solid fa-angle-down" />
            </button>

            <Menu
                id="basic-menu-language"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                {languages.map(language => (
                    <MenuItem className={props.className} onClick={() => handleClose(language.languageCode)} key={`language_MenuItem_${language.languageCode}`}>
                        {language.description}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default LanguageButton;
